module.exports = __webpack_public_path__ + "static/media/my-digital-store.33db03e5.svg";